import { createReducer, on } from '@ngrx/store';
import * as StbActions from './stb.actions';

export const stbFeatureKey = 'stb';

export const externalAppIds: string[] = [
  'com.webos.app.livetv',
  'com.webos.app.hdmi1',
  'com.webos.app.hdmi2',
  'com.webos.app.hdmi3',
];

export interface StbState {
  currentInputType: string;
  currentInputIndex: number;
  cpuUsage: number;
  memoryUsage: number;
  foregroundAppId: string;
}

const initialState: StbState = {
  currentInputType: undefined,
  currentInputIndex: undefined,
  cpuUsage: 0,
  memoryUsage: 0,
  foregroundAppId: '',
};

export const stbReducer = createReducer<StbState>(
  initialState,
  on(StbActions.setCurrentInput, (state, action) => ({
    ...state,
    currentInputType: action.typ,
    currentInputIndex: action.index,
  })),
  on(StbActions.getCpuUsageSuccess, (state, action) => ({
    ...state,
    cpuUsage: action.percentage,
  })),
  on(StbActions.getMemoryUsageSuccess, (state, action) => ({
    ...state,
    memoryUsage: action.percentage,
  })),
  on(
    StbActions.setForegroundAppId,
    StbActions.getForegroundAppIdSuccess,
    (state, action) => ({
      ...state,
      foregroundAppId: action.appId,
    })
  ),
  on(StbActions.clearForegroundAppId, (state) => ({
    ...state,
    foregroundAppId: '',
  }))
);
